export default "__VITE_ASSET__C2Wm$9CT__"